import dayjs from 'dayjs';

import {
    CreateYandexStoryRequestType,
    YandexStoryFormFieldsEnum,
    YandexStoryFormType,
    YandexStoryStatusEnum,
} from './yandex-stories-type';

export function prepareCreateYandexStoryRequestData(data: YandexStoryFormType): CreateYandexStoryRequestType {
    const firstSlide = Object.values(data.slides).find((slide) => slide.order === 1);

    const [publishAt, deleteAt] = data[YandexStoryFormFieldsEnum.PublicationRange] ?? [null, null];

    // Only a publish date that is still ahead schedules the story. An already published story keeps
    // its publish date, so a bare truthiness check would re-schedule it on every update.
    const isScheduled = Boolean(publishAt?.isAfter(dayjs()));

    const cover =
        data[YandexStoryFormFieldsEnum.Cover] ||
        (firstSlide
            ? {
                  id: firstSlide.id,
                  url: firstSlide.url,
              }
            : {
                  id: '',
                  url: '',
              });

    return {
        selectorId: data[YandexStoryFormFieldsEnum.CompaniesSelector],
        name: data[YandexStoryFormFieldsEnum.Name],
        cover,
        slides: Object.values(data.slides).map((slide) => ({
            image: {
                id: slide.id,
                url: slide.url,
            },
            order: slide.order,
            buttonConfig: slide.buttonConfig,
        })),
        type: data.type,
        autoAddCompanies: data[YandexStoryFormFieldsEnum.AutoAddCompanies],
        // A publish date in the future schedules the story (planned); otherwise publish now.
        status: isScheduled ? YandexStoryStatusEnum.Planned : YandexStoryStatusEnum.InProgress,
        publishAt: publishAt ? publishAt.toISOString() : null,
        deleteAt: deleteAt ? deleteAt.toISOString() : null,
    };
}
